import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'wk-unassignable-document-dialog',
  templateUrl: 'wk-unassignable-document-dialog.component.html',
  styleUrls: ['./wk-unassignable-document-dialog.component.scss'],
  standalone: false,
})
export class WkUnassignableDocumentDialogComponent {
  canReassign = false;
  constructor(@Inject(MAT_DIALOG_DATA) data: { canReassign: boolean }) {
    this.canReassign = data.canReassign;
  }
}
